// extracted by mini-css-extract-plugin
export default {"box":"EmployeeAuthority_box__j0fN8","wrapperPadding":"EmployeeAuthority_wrapperPadding__Zf2yS","searchBox":"EmployeeAuthority_searchBox__N1qyb"};